import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-rangeslider';
import GenericButton from "../common/GenericButton";
import infoIconBlackOutline from '../../images/insight360/info-icon_black_outline.png';
import { INSIGHT_360_PERCENTAGE_FILTER_INFO } from '../../constants';

class PercentageFilterSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: this.props.value ? this.props.value : 0,
    };
  }

  handleVpctSliderChange = value => {
    this.setState({
      sliderValue: value,
    });
  };

  applyVpctSliderVal = () => {
    if (this.props.value !== this.state.sliderValue) {
      this.props.applyVpctFilter(this.state.sliderValue);
    }
  };

  render() {
    return (
      <div className="row percentage-filter">
        <div className="columns percentage-filter-clmn text-align-right">
          REACH
          <img
            className="i360_header_icons_img"
            src={infoIconBlackOutline}
            alt={INSIGHT_360_PERCENTAGE_FILTER_INFO}
            title={INSIGHT_360_PERCENTAGE_FILTER_INFO}
          />
        </div>
        <div className="perFilterStartLabel">0%</div>
        <div className="columns custom-rangeslider-horizontal">
          <Slider
            min={0}
            max={100}
            value={this.state.sliderValue}
            orientation="horizontal"
            tooltip={false}
            onChange={this.handleVpctSliderChange}
            labels={{}}
            handleLabel={`${this.state.sliderValue}%`}
          />
        </div>
        <div className="columns percentage-filter-clmn text-align-left">
          <span className="perFilterEndLabel">100%</span>
          <GenericButton
            name="Apply"
            btnStyle={`i360-cmn-btn size-small ${
              this.props.value !== this.state.sliderValue
                ? 'active-btn'
                : 'disabled-btn'
            }`}
            onBtnClick={this.applyVpctSliderVal}
          />
        </div>
      </div>
    );
  }
}

PercentageFilterSlider.propTypes = {
  value: PropTypes.number,
  applyVpctFilter: PropTypes.func,
};

export default PercentageFilterSlider;
